import { getDownloadURL, getStorage, ref } from "@firebase/storage";
import { action, makeAutoObservable } from "mobx";
import { firebaseApp } from "../StApp";
import { ChatsRequest } from "../models/api/ChatsRequest";
import { AuthRequest } from "../models/api/NetworkRequest";
import { UserChatItem } from "../models/api/UserChatItem";
import { ProgStatus } from "../models/utilTypes";
import ApiService from "../services/ApiService";
import { db } from "../services/DexieDbImpl";
import { rootStore } from "../StApp";

export default class ChatStore {

    chatList: UserChatItem[] = []
    loadProg: ProgStatus = 'LOADING'
    refreshProg: ProgStatus = 'INIT'




    constructor() {

        makeAutoObservable(this)

    }

    refreshChats(){
        this.refreshProg = 'LOADING'
        this.loadAllChats()
    }

    async loadAllChats() {

        if (this.chatList.length < 1) {

            //0. Show loader
            //1. Fetch chats remotely
            //2. Store them in db
            //3. Update UI from db

            this.loadProg = 'LOADING'
            await this.fetchAllChatsRemotely()
            this.loadProg = 'SUCCESS'
            db.getAllVChats().then(resp => {
                this.chatList = resp
            })
        }
        else {

            this.fetchAllChatsRemotely().then(() => {
                db.getAllVChats().then(resp => {
                    this.refreshProg = 'SUCCESS'
                    this.chatList = resp
                })
            })
        }

        // db.getAllVChats().then(resp => {
        //     this.chatList = resp
        // })
    }

    @action
    private async fetchAllChatsRemotely() {


        let authChatReq: AuthRequest<ChatsRequest> = {
            auth: rootStore.mainStore.token,
            data: {
                limit: 10,
                queryCursor: 'as',
                uid: rootStore.mainStore.uid!,
                userId: rootStore.mainStore.userName
            }
        }
        //this.loadProg = 'LOADING'

        try {

            const resp = await ApiService.getAllChats(authChatReq)
            await db.updateBulkVChat(resp.data)

        } catch (err) {
            console.error(err)
        }


    }

    fetchAllChatsSilently() {

    }

    fetchChatById() {

    }

    async fetchVNoteAudioUrl(chatMsg: UserChatItem) {

        try {
            console.log(`${chatMsg.chatId}/${chatMsg.lastChatMsg.voice}`)
            const storage = getStorage(firebaseApp)
            return await getDownloadURL(ref(storage, `${chatMsg.chatId}/${chatMsg.lastChatMsg.voice}`))
        } catch (err) {
            console.error(err)
        }

    }




}